/**
 * Created by Claude on 2026-02-04
 * Resizable component - provides resizable functionality via ComponentMap
 */

class Resizable extends BaseComponent {
    onCreate() {
        // vertical: false (a value or a "#..." reference) keeps the horizontal view in both modes -
        // a window whose data has no vertical art is laid out as before
        const vertical = this.options.vertical === undefined || PrefabBuilder.resolveProperty(this.options.vertical, this.context) !== false;

        this.createHorizontalView = this.options.createHorizontalView;
        this.createVerticalView = vertical ? this.options.createVerticalView : undefined;

        if (this.options.horizontalPrefab) {
            this.createHorizontalView = () => PrefabBuilder.buildNode(this.options.horizontalPrefab, this.context);
        }

        if (vertical && this.options.verticalPrefab) {
            this.createVerticalView = () => PrefabBuilder.buildNode(this.options.verticalPrefab, this.context);
        }
    }

    onAttach() {
        this.onResize();
    }

    onReady() {
        this.wasReady = true;
    }

    updateView() {
        const node = this.node;
        const mode = cleverapps.resolution.isVertical() && this.createVerticalView ? "vertical" : "horizontal";

        if (this.content && this.mode === mode) {
            return;
        }

        const isRebuild = Boolean(this.content);

        this.mode = mode;

        if (this.content) {
            this.content.removeFromParent();
        }

        const createView = mode === "vertical" ? this.createVerticalView : this.createHorizontalView;
        this.content = createView();
        this.content.setPosition(node.width / 2, node.height / 2);
        node.addChild(this.content);

        if (isRebuild) {
            if (this.wasReady) {
                cc.Base.PerformRecursiveFromLeaves(this.content, (child) => {
                    ComponentMap.callHooks(child, "onReady");
                });
            }

            cc.Base.PerformRecursiveFromLeaves(this.content, (child) => {
                ComponentMap.callHooks(child, "onResize");

                if (child.onResize) {
                    child.onResize();
                }
            });

            cc.Base.PerformRecursiveFromLeaves(this.content, (child) => {
                ComponentMap.callHooks(child, "onAfterResize");

                if (child.onAfterResize) {
                    child.onAfterResize();
                }
            });
        }

        if (this.onContentChanged) {
            this.onContentChanged();
        }
    }

    onResize() {
        const node = this.node;
        const sceneSize = cleverapps.resolution.getSceneSize();

        node.setContentSize(sceneSize.width, sceneSize.height);

        this.updateView();

        if (this.content) {
            if (this.content.onResize) {
                this.content.onResize();
            }
            this.content.setPosition(node.width / 2, node.height / 2);
        }

        if (this.options.fitToContent) {
            if (this.content) {
                node.setContentSize(this.content.getContentSize());

                this.content.setPosition(node.width / 2, node.height / 2);
            } else {
                this.setContentSize(0, 0);
            }
        }
    }
}

Prefab.registerComponent("Resizable", Resizable);
